import { useMemo } from 'react';

import { ActionDateRange } from 'modules/search/components/Facet/ActionDateRange';
import { LocaleFacet } from 'modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from 'modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from 'modules/search/components/Facet/OrgAreasOfFocusFacet';
import { RadiusFacet } from 'modules/search/components/Facet/RadiusFacet';
import { RecencyFacet } from 'modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from 'modules/search/components/Refinements/SearchRefinements';

import { VolopKeywordsFacet } from './VolopKeywordsFacet';
import { VolopSourceFacet } from './VolopSourceFacet';

export function SearchVolopsRefinements() {
  const refinementsByLocale = useMemo(
    () => ({
      en: [
        LocationTypeFacet,
        OrgAreasOfFocusFacet,
        VolopSourceFacet,
        ActionDateRange,
        VolopKeywordsFacet,
        LocaleFacet,
        RecencyFacet,
        RadiusFacet,
      ],
      es: [
        LocaleFacet,
        LocationTypeFacet,
        OrgAreasOfFocusFacet,
        VolopSourceFacet,
        ActionDateRange,
        VolopKeywordsFacet,
        RecencyFacet,
        RadiusFacet,
      ],
      pt: [
        LocaleFacet,
        LocationTypeFacet,
        OrgAreasOfFocusFacet,
        VolopSourceFacet,
        ActionDateRange,
        VolopKeywordsFacet,
        RecencyFacet,
        RadiusFacet,
      ],
    }),
    [],
  );

  return (
    <SearchRefinements listingType="VOLOP">
      {refinementsByLocale[CURRENT_LOCALE()].map((Component) => (
        <Component key={Component.name} />
      ))}
    </SearchRefinements>
  );
}
